var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 4.06006L12.3058 4.26345L20.2369 9.55082L20.9233 10.0084L20.2369 10.4661L12.3058 15.7534L12.0007 15.9568L11.6956 15.7534L3.76457 10.4661L3.07812 10.0084L3.76457 9.55082L11.6956 4.26345L12.0007 4.06006ZM5.06118 10.0084L12.0007 14.6348L18.9402 10.0084L12.0007 5.38209L5.06118 10.0084ZM11.7139 20.1713L3.78285 15.3245L4.35645 14.3859L12.0007 19.0574L19.645 14.3859L20.2186 15.3245L12.2875 20.1713L12.0007 20.3465L11.7139 20.1713Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/App.cc04ce652ebdf60b077b921b926b8e34.svg";
export { ForwardRef as ReactComponent };